import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { evaluateRoute } from "../app/routes/routePolicy";
import { resolveVendorCapability } from "@/domain/vendorCapabilities";

/**
 * Route guards for owner access, plan limits, and restaurant capabilities.
 */

/** Owner-only route. */
export function RequireOwner({ children }) {
  const { vendor, loading, isOwner } = useAuth();
  if (loading) return null;
  const decision = evaluateRoute(
    { guard: "owner" },
    !vendor ? { kind: "anonymous" } : isOwner ? { kind: "vendor", onboarded: true } : { kind: "anonymous" }
  );
  return decision.outcome === "allow" ? children : <Navigate to={decision.to} replace />;
}

/**
 * Owner route with an optional plan gate against the plan matrix
 * (e.g. features="multiStore" blocks the page if the vendor's plan
 * doesn't include multi-storefront).
 */
export function RequirePermission({ perm, feature, children, fallback = "/dashboard/pos" }) {
  const { vendor, loading, isOwner } = useAuth();
  if (loading) return null;
  if (!vendor) return <Navigate to={evaluateRoute({ guard: perm }).to} replace />;
  if (feature && !vendor.features?.[feature]) return <Navigate to="/dashboard" replace />;
  return isOwner ? children : <Navigate to={fallback} replace />;
}

export function RequireCapability({ capability, permission, children, fallback = "/dashboard" }) {
  const { vendor, loading, isOwner } = useAuth();
  if (loading) return null;
  if (!resolveVendorCapability({ vendor, isOwner, capability })) return <Navigate to={fallback} replace />;
  return children;
}
